/**
 * Autocomplete types
 */
const CATEGORY_OPTIONS = {
  GAS: 'gas',
  ELECTRICITY: 'electricity',
  GAS_AND_ELECTRICITY: 'gasAndElectricity',
  NONE: 'none',
};

export default CATEGORY_OPTIONS;
